import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({ 
  title = "Suguna Crackers | Sivakasi Crackers Wholesale & Retail", 
  type = "website", 
  siteName = "Suguna Crackers", 
  url = "https://sugunacrackers.com", 
  keywords = "suguna crackers, sivakasi crackers, buy crackers online, wholesale crackers sivakasi, diwali crackers, firecrackers sivakasi", 
  description = "Buy authentic Sivakasi crackers directly from godown at wholesale factory prices. Premium quality sparklers, rockets, gift boxes & festival combos.", 
  image = "https://sugunacrackers.com/og-image.jpg",
  revisitAfter = "7 Days" 
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="revisit-after" content={revisitAfter} />
      <meta name="author" content="Suguna Crackers" />
      <meta name="copyright" content="Suguna Crackers" />
      <meta name="language" content="English" />
      <meta name="distribution" content="Global" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Suguna Crackers Sivakasi Wholesale Fireworks" />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default MetaTags;
